import { Injectable, signal, effect } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  isDarkMode = signal<boolean>(this.getInitialTheme());

  constructor() {
    // Apply initial theme immediately
    this.applyTheme(this.isDarkMode());

    effect(() => {
      const dark = this.isDarkMode();
      this.applyTheme(dark);
      localStorage.setItem('equity_theme', dark ? 'dark' : 'light');
    });
  }

  toggleTheme() {
    this.isDarkMode.update(v => !v);
  }

  private getInitialTheme(): boolean {
    const saved = localStorage.getItem('equity_theme');
    if (saved) {
      return saved === 'dark';
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  }

  private applyTheme(dark: boolean) {
    const html = document.documentElement;
    const body = document.body;
    if (dark) {
      html.setAttribute('data-bs-theme', 'dark');
      body?.setAttribute('data-bs-theme', 'dark');
      html.classList.remove('light-style');
      html.classList.add('dark-style');
    } else {
      html.setAttribute('data-bs-theme', 'light');
      body?.setAttribute('data-bs-theme', 'light');
      html.classList.remove('dark-style');
      html.classList.add('light-style');
    }
  }
}
